import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon, MailIcon } from '@heroicons/react/outline'

export default function Step10({ nextStep, prevStep, updateFieldValue, value }) {

    const [email, setEmail] = useState(value)
    const [error, showError] = useState(false)
    const validEmail = new RegExp(
        '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
    );

    const handleNextStep = () => {
        if (email === "" || !validEmail.test(email) || !email || email.length === 0) {
            showError(true)
        } else {
            nextStep(10)
        }
    }

    // console.log("email", email)


    return (
        <div id="step10" >
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-4 md:px-6'>What is the best email address for you?</legend>
                    <p className="font-normal italic text-sm px-4 md:px-6 text-gray-600 mt-2 mb-8">
                        Your email is protected and will only be shared with your Tax Advocate.
                    </p>
                    <div className='relative mt-5 ml-2 text-base text-gray-800'>
                        <MailIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
                        <input
                            type="text"
                            name="email"
                            maxLength="100"
                            defaultValue={value}
                            onChange={(e) => {
                                updateFieldValue("email", e.target.value);
                                setEmail(e.target.value);
                            }}
                            className={`w-full h-12 rounded-md border font-semibold text-base transition-colors pl-11 pr-4
               ${error
                                    ? "border-red-600 bg-red-50"
                                    : "border-gray-400 bg-white"
                                }`}
                        />
                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please enter a valid email address.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep10Prev"
                    onClick={() => prevStep(10)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    10 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep10Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>

        </div>
    );
}